import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { calculateAdvancement } from "../../utils/calculateAdvancement";

function handleRemoveResourceFromProject(
  task: Identifiable<Task>,
  {
    tasks,
    projectResource,
    hasRequestedAllocationTransfer,
    destinationResource,
  }: Boundaries["removeResourceFromProject"]["success"],
): Identifiable<Task> {
  if (
    hasRequestedAllocationTransfer &&
    tasks.some((t) => t.uuid === task.uuid)
  ) {
    return calculateAdvancement({
      ...task,
      allocations: task.allocations.map((allocation) =>
        allocation.resource.uuid === projectResource.resource.uuid
          ? { ...allocation, resource: destinationResource.resource }
          : allocation,
      ),
    });
  }

  return calculateAdvancement({
    ...task,
    allocations: task.allocations.filter(
      (allocation) =>
        allocation.resource.uuid !== projectResource.resource.uuid,
    ),
  });
}

export { handleRemoveResourceFromProject };
